import { useCallback, useSyncExternalStore } from 'react';

import type { NoteBlockStore } from '../lib';

export const useNoteBlockEntry = <T>(
  store: NoteBlockStore<T>,
  blockId: string,
): T | undefined =>
  useSyncExternalStore(
    // A new subscribe function would subscribe again on every render.
    useCallback(
      (listener: () => void) => store.subscribe(blockId, listener),
      [store, blockId],
    ),
    () => store.get(blockId),
  );
